import React from 'react';

const LoanDetailContext = React.createContext({ loan_id: '', loan_detail: () => {} });

export default LoanDetailContext;
